import { GetRecipeDiscussionByEmailMeta, GetRecipeDiscussionByEmailPayload } from 'types/store/GetRecipeDiscussionByEmail';
import { createAsyncReducer } from 'utils/Redux';

import { getRecipeDiscussionByEmailActions } from '../actions';

export default createAsyncReducer<GetRecipeDiscussionByEmailMeta, GetRecipeDiscussionByEmailPayload>(getRecipeDiscussionByEmailActions);
